import { PayloadAction } from "@reduxjs/toolkit";

import { Types } from "../../../../services";
import { DirectDebtState } from "../../../../utils/types";

// Patch Direct Debt Reducers
export const patchDirectDebtPending = (state: DirectDebtState) => {
  state.getDirectdebt.loadingStatus = "loading";
  state.getDirectdebt.error = undefined;
  state.getDirectdebt.data = undefined;
};

export const patchDirectDebtFulfilled = (
  state: DirectDebtState,
  action: PayloadAction<
    Types.ApiResponse<Types.PromoDetailsTypes.PatchPromoResponse>
  >
) => {
  state.getDirectdebt.loadingStatus = "loaded";
  state.getDirectdebt.data = action.payload;
};

export const patchDirectDebtRejected = (
  state: DirectDebtState,
  action: any
) => {
  state.getDirectdebt.loadingStatus = "error";
  state.getDirectdebt.error = action.payload || action.error;
};

export const patchDirectDebtDiscoveryPending = (state: DirectDebtState) => {
  state.getDirectdebtDiscovery.loadingStatus = "loading";
  state.getDirectdebtDiscovery.error = undefined;
  state.getDirectdebtDiscovery.data = undefined;
};

export const patchDirectDebtDiscoveryFulfilled = (
  state: DirectDebtState,
  action: PayloadAction<
    Types.ApiResponse<Types.PromoDetailsTypes.PatchPromoResponse>
  >
) => {
  state.getDirectdebtDiscovery.loadingStatus = "loaded";
  state.getDirectdebtDiscovery.data = action.payload;
};

export const patchDirectDebtDiscoveryRejected = (
  state: DirectDebtState,
  action: any
) => {
  state.getDirectdebtDiscovery.loadingStatus = "error";
  state.getDirectdebtDiscovery.error = action.payload || action.error;
};

